/**
 * CSRF Token Utility
 *
 * Flask-JWT-Extended sends CSRF tokens in cookies when JWT_COOKIE_CSRF_PROTECT is enabled.
 * We need to read these cookies and include them in request headers.
 */

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

/**
 * Get CSRF token from cookies
 * Flask-JWT-Extended stores it as 'csrf_access_token' by default
 */
export function getCSRFToken(): string | null {
  return getCookie('csrf_access_token');
}

/**
 * Add CSRF token to fetch headers if available
 */
export function addCSRFHeader(headers: HeadersInit = {}): HeadersInit {
  const csrfToken = getCSRFToken();

  if (csrfToken) {
    return {
      ...headers,
      'X-CSRF-TOKEN': csrfToken
    };
  }

  return headers;
}
